import * as React from 'react';
import { SessionNote, SubjectNote, TestNote } from 'webportalclient';
import { NotesModal } from "../../misc/components/NotesModal";

export interface NotesPanelProps {
    header: string;
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    isAddingNotesEnabled: boolean;
    showNotesCount?: boolean;
    onAddNote: (annotation: string) => void;
}

export const NotesPanel = (props: NotesPanelProps) => {
    const [isModalVisibility, setIsModalVisibility] = React.useState(false);
    const [isAddingNewNote, setIsAddingNewNote] = React.useState(false);

    return (
        <>
            <div className="panel panel-default">
                <div className="panel-body">
                    <button className="btn btn-primary" onClick={() => setIsModalVisibility(true)} data-automationid="NotesButton">
                        {props.header}
                        {props.showNotesCount ? <>&nbsp;<span className="badge badge-info">{props.notes.length}</span></> : null}
                    </button>
                </div>
            </div>
            <NotesModal
                isVisible={isModalVisibility}
                header={props.header}
                isAddingNote={isAddingNewNote}
                notes={props.notes}
                onAdd={annotation => { setIsAddingNewNote(true); props.onAddNote(annotation); setIsAddingNewNote(false); }}
                onCloseModal={() => setIsModalVisibility(false)}
                disabled={!props.isAddingNotesEnabled}
            />
        </>
    );
}

export default NotesPanel;
